// extracted by mini-css-extract-plugin
export default {"fab":"fab--l7zo4","fabIcon":"fabIcon--TGILb"};